import { EBehavior } from '../../../enums/EBehavior';
import { prepareMultiplyCheckboxGroupsItemChangeModel } from './prepareMultiplyCheckboxGroupsItemChangeModel';
import { prepareSingleCheckboxGroupsItemChangeModel } from './prepareSingleCheckboxGroupsItemChangeModel';
export var prepareCheckboxGroupsItemChangeModelFactory = function prepareCheckboxGroupsItemChangeModelFactory(behavior) {
  return function (groups, checkboxGroupItemChangeModel) {
    switch (behavior) {
      case EBehavior.Single:
        return prepareSingleCheckboxGroupsItemChangeModel(checkboxGroupItemChangeModel);

      case EBehavior.Multiply:
      case EBehavior.SingleInOneGroup:
        return prepareMultiplyCheckboxGroupsItemChangeModel(groups, checkboxGroupItemChangeModel);
    }
  };
};